<app-nav titulo="Configuración" descripcion="Configure los parámetros de su cuenta.">
    <div class="settings">
        <form class="settings-section" [formGroup]="passwordResetFG" (ngSubmit)="passwordResetFG.valid && changePassword()">
            <span class="settings-section-title">Cambio de contraseña</span>
            <span class="settings-section-description">Si desea cambiar su contraseña, escriba la nueva y presione "Cambiar contraseña".</span>
            <div class="change-password">
                <mat-form-field class="garantor-form-field default-suffix" appearance="outline">
                    <mat-label>Nueva contraseña</mat-label>
                    <input matInput [type]="showPassword ? 'text' : 'password'" formControlName="password" required>
                    <mat-error *ngIf="passwordResetFG.controls.password.hasError('required')">
                        Por favor ingrese una nueva contraseña
                    </mat-error>
                    <button mat-icon-button matSuffix class="show-password-icon" type="button" (click)="showPassword = !showPassword; $event.stopPropagation()">
                        <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                </mat-form-field>
                <mat-form-field class="garantor-form-field default-suffix" appearance="outline">
                    <mat-label>Confirmar contraseña</mat-label>
                    <input matInput [type]="showPasswordConfirm ? 'text' : 'password'" formControlName="passwordConfirm" required>
                    <mat-error *ngIf="passwordResetFG.controls.passwordConfirm.hasError('required')">
                        Por favor ingrese una contraseña
                    </mat-error>
                    <mat-error *ngIf="passwordResetFG.controls.passwordConfirm.hasError('notEquals')">
                        Las contraseñas no son iguales
                    </mat-error>
                    <button mat-icon-button matSuffix class="show-password-icon" type="button" (click)="showPasswordConfirm = !showPasswordConfirm; $event.stopPropagation()">
                        <mat-icon>{{ showPasswordConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                </mat-form-field>
                <button mat-raised-button color="primary" class="garantor-button change-password-button">
                    Cambiar contraseña
                </button>
            </div>
        </form>
    </div>
</app-nav>
